import { Component, EventEmitter, forwardRef, OnInit, Output, Type } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { ToasterService } from 'angular2-toaster';
import { ConfigService } from 'app/services/config.service';
import { StorageCategories } from 'app/services/database/storage.service';
import { FileModel, FileModelBuilder } from 'app/views/presentations/models/file.model';
import { VideoDisplayModeType, VideoModel } from 'app/views/presentations/models/video.model';
import { Widget } from 'app/views/presentations/widgets/widget';
import { WidgetComponent } from 'app/views/presentations/widgets/widget.component';

export class VideoWidget extends Widget {
    public type: string = 'Video';
    public icon: string = 'fa-video-camera';
    public nameResourceKey: string = 'modules.editors.video.name';
    public componentType: Type<WidgetComponent> = VideoWidgetComponent;
}

@Component({
    selector: 'psm-video-widget',
    templateUrl: 'video.widget.html'
})
export class VideoWidgetComponent extends WidgetComponent<VideoModel> {
    public maxFileSize: number;
    public defaultDisplayMode: VideoDisplayModeType = VideoDisplayModeType.Restrict;
    public displayModes: VideoDisplayModeType[] = Object.keys(VideoDisplayModeType) as VideoDisplayModeType[];
    public videoForm: FormControl = new FormControl('video', (validator) => {
        if (this.files.length > 0) return;
        return { 'modules.editors.video.video-required': true };
    });

    constructor(private configService: ConfigService, private toasterService: ToasterService) {
        super();
    }

    public async initialize() {
        this.maxFileSize = await this.configService.get('maxFileSize', 4096);
        this.defaultDisplayMode = await this.configService.get('defaultDisplayMode', VideoDisplayModeType.Restrict);

        if (!this.content) {
            this.content = new VideoModel(this.defaultDisplayMode);
        }
    }

    public onMaxFileSizeExceeded() {
        this.toasterService.pop('error', '', 'modules.super-admin.configurations.file-exceeds-maximum-size');
    }

    public onFileTypeInvalid() {
        this.toasterService.pop('error', '', 'modules.super-admin.configurations.file-type-invalid');
    }

    public setVideoFile(file: File) {
        const fileModel = new FileModelBuilder();

        fileModel.category = StorageCategories.Videos;
        fileModel.file = file;
        fileModel.name = file.name;
        fileModel.size = file.size;

        this.files = [fileModel];
    }

    public async getFormControls(): Promise<AbstractControl[]> {
        return [this.videoForm];
    }
}



// WEBPACK FOOTER //
// ./src/app/views/presentations/widgets/video/video.widget.ts